/*********************************************************
 *                  Info Ctrl
 *
 ********************************************************/


"use strict";

angular.module("exploitation")
	.controller("InfoCtrl", ["$scope", "$location", "Utils", "info", "InfoService", "toastr", function ($scope, $location, Utils, info, InfoService, toastr) {

		/************************************************************************************************************
		 *  SETUP
		 *************************************************************************************************************/

		$scope.data = {
			info: info.data
		};

		$scope.post = function () {
			InfoService.editFeedInfo($scope.data.info).then(() => {
				toastr.success("", "Informations mises à jour");
			}).catch(() => {
				toastr.error("Problème lors de la mise à jour des informations.", "Erreur");
			});
		};

	}]);